// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-overview-page',
    // #endregion
    // #region Properties
    props: {
        mode: {
            type: String,
            required: false,
            default: '__active'
        },
    },
    data: () => ({
        processes: [],
        history: [],
        running: [],
        schemas: [],
        isLoaded: false
    }),
    computed: {
        isNew() {
            return this.mode === 'all' || this.mode === 'new';
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.refresh();
    },
    // #endregion
    // #region Methods
    methods: {
        async onCreateNew(schemaName, version) {
            //Create
            let tResult = await this.$host.api.post('/forms/processes/' + schemaName + '/' + version);
            //Move-To
            if (tResult.data.processID) {
                this.$router.push('/ozg/' + tResult.data.processID);
            }
        },
        refresh() {
            if (this.isNew) {
                this.$host.api.get('/forms/processes/schemas/ozg')
                    .then(e => {
                    this.schemas = e.data;
                    this.isLoaded = true;
                });
            }
            else {
                this.$host.api.get('/forms/processes/list?states=' + this.mode)
                    .then(e => {
                    this.processes = e.data;
                    this.isLoaded = true;
                });
            }
        },
        deleteProcess(process) {
            this.$host.api.delete('/forms/processes/' + process.processID)
                .then(e => {
                this.refresh();
            });
        },
        onGoto(process) {
            this.$router.push('/ozg/' + process.processID);
        },
        onDelete(process) {
            this.$host.notification.showQuestion({
                title: "Prozess löschen",
                message: "Möchten Sie den Prozess " + process.prorcessNumber + " wirklich löschen?",
                successCallback: () => this.deleteProcess(process)
            });
        },
        async onDocuments(process) {
            //Create
            let tResult = await this.$host.api.post('/forms/processes/' + process.processID + '/sub/documents');
            //Move-To
            if (tResult.data.processID) {
                this.$router.push('/ozg/' + tResult.data.processID);
            }
        },
        async onInfo(schema) {
            host.notification.showModal2(host.components.getComponent('g-ozg-schema_info'), { label: `${schema.label} [${schema.shortCut}] (${schema.description})`, schema: schema }, { variant: "slide", position: "bottom", size: "default" });
        },
        async onMissingDocuments(process) {
            host.notification.showModal2(host.components.getComponent('g-ozg-summary_documents'), { label: `Antrag: ${process.processNumber}, ${process.caption}`, process: process }, { variant: "slide", position: "bottom", size: "default" });
        },
    }
    // #endregion
});
// #endregion
